import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=e323669e&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e323669e",
  null
  
)

export default component.exports